import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function LentilShepherdsPie() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Lentil Shepherds Pie</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>Lentil Filling</b>
        <br></br>1 tablespoon olive oil<br></br>3 large yellow onions, diced
        <br></br>8 cloves garlic minced (use less if you're not a huge fan of
        garlic)<br></br>1 tablespoon fresh thyme leaves, roughly chopped
        <br></br>2 teaspoons fresh rosemary leaves, roughly chopped<br></br>3
        tablespoons tomato paste<br></br>
        1/2 cup (120 mL) dry red wine<br></br>1 1/2 cups (10 ounces / 285g)
        green lentils (or brown lentils)<br></br>3 3/4 cups (900 mL) vegetable
        broth<br></br>2 bay leaves<br></br>1 1/2 teaspoons sweet or hot paprika
        <br></br>
        1/4 cup (56g) smooth tahini**<br></br>1 tablespoon tamari (or soy sauce)
        <br></br>1 tablespoon good-quality balsamic vinegar<br></br>2 teaspoons
        vegan Worcestershire sauce (optional)<br></br>
        Plenty of kosher salt or sea salt (I used 1 1/2 - 2 teaspoons kosher
        salt)<br></br>
        Freshly cracked black pepper to taste<br></br>
        <b>Mashed Potato Topping</b>
        <br></br>
        20 ounces (680g) Russet potatoes<br></br>
        16 ounces (454g) cauliflower, cut into large florets<br></br>
        <br></br>1 1/2 teaspoons kosher salt, plus more to taste<br></br>1
        rosemary sprig (optional)<br></br>4 tablespoons vegan butter, softened
        at room temperature (or olive oil)<br></br>
        1/2 cup (120 mL) “lite” coconut milk<br></br>1 tablespoon nutritional
        yeast<br></br>
        Freshly cracked black pepper to taste<br></br>
        <b>Optional finishes and garnishes</b>
        <br></br>
        Extra virgin oil for baking and finishing<br></br>
        Flaky sea salt and black pepper<br></br>
        Fresh thyme leaves<br></br>
        Chopped flat-leaf parsley<br></br>
      </Typography>

      <Typography>
        Make the Lentil Filling. <br></br>
        Heat the olive oil in an ovenproof 12-inch skillet over medium to
        medium-high heat until hot. <br></br>
        If you don't have an ovenproof skillet, you'll need to transfer the
        cooked lentil filling to a baking dish when it's time to bake.<br></br>
        <br></br>
        Add the onions with a couple pinches of salt and sauté for 8-10 minutes,
        or until most of the onions are browned. <br></br>
        Stir occasionally to prevent burning, but not too often so that they can
        brown. <br></br>
        Add the garlic, thyme and rosemary and cook for 2 minutes, stirring
        frequently to prevent burning.<br></br>
        <br></br>
        Push the onions to the edges of the pan so there's an empty space in the
        middle of the pan. <br></br>
        Add the tomato paste into the empty space and stir for 2-3 minutes, or
        until it darkens in color. <br></br>
        Reduce the heat to medium, as needed.<br></br>
        <br></br>
        Pour in the red wine and deglaze the pan, stirring up any browned bits,
        until the liquid has mostly evaporated and the smell of alcohol has
        dissipated, about 3-4 minutes.<br></br>
        <br></br>
        Add the vegetable broth, along with the lentils, bay leaves, and
        paprika. <br></br>
        Stir to combine and increase the heat to bring to a boil. <br></br>
        Once boiling, reduce heat to maintain a rapid simmer, and simmer until
        the lentils are just tender and most of the liquid has been absorbed,
        25-30 minutes.<br></br>
        <br></br>
        Turn the heat to low. <br></br>
        Add the tahini, tamari, balsamic vinegar, and vegan Worcestershire sauce
        (if using). <br></br>
        Stir until well incorporated. Taste for seasonings, adding a generous
        amount of salt (I used about 1 teaspoon kosher salt) and black pepper.{" "}
        <br></br>
        Set aside.<br></br>
        <br></br>
        Make the Mashed Potato Topping. <br></br>
        Peel the Russet potatoes and then rinse them under cold water. <br></br>
        Chop the potatoes into eighths.<br></br>
        <br></br>
        Place the potatoes and cauliflower florets in a large saucepan or Dutch
        oven and add just enough water to cover. <br></br>
        Add 1 1/2 teaspoons kosher salt and stir to combine. <br></br>
        Place the rosemary sprig on top. <br></br>
        Bring to a boil and cook until both potatoes and cauliflower are
        fork-tender and are very soft when poked, about 15 minutes.<br></br>
        <br></br>
        Thoroughly drain the potatoes and cauliflower in a colander and discard
        the rosemary sprig. <br></br>
        For the potatoes, pat them dry with paper towels or a clean dish towel.{" "}
        <br></br>
        For the cauliflower, you'll need to squeeze out the excess water or
        it'll be very watery.<br></br>
        <br></br>
        Return the vegetables to the saucepan or transfer them to a large bowl.{" "}
        <br></br>
        Add in the softened vegan butter, lite coconut milk, nutritional yeast,
        along with salt and black pepper to taste. <br></br>
        Mash together. <br></br>
        Taste for seasonings, adding more salt as needed.<br></br>
        <br></br>
        Assemble the Shepherd's Pie. <br></br>
        Preheat the oven to 375°F/190°C. <br></br>
        If your skillet is ovenproof and has enough space, leave the Lentil
        Filling in there. <br></br>
        If not, transfer it to a large (3 quart/3 liter) baking dish. <br></br>
        Smooth the Lentil Filling out. <br></br>
        Then, spoon and carefully spread out the Mashed Potato Topping on top,
        covering the whole surface. <br></br>
        For more flavor, drizzle the top with extra virgin olive oil and some
        extra pinches of salt, pepper, and fresh thyme leaves.<br></br>
        <br></br>
        Bake for 20 minutes, or until the lentil filling starts to bubble up.{" "}
        <br></br>
        Remove from the oven and turn on your oven's broiler. <br></br>
        Place the pan under the broiler for a few minutes until the crust is
        golden brown. <br></br>
        To finish, drizzle with more olive oil and garnish with fresh parsley,
        if desired.<br></br>
        <br></br>
        Note: if you want the pie to solidify more, allow it to rest for at
        least 20 minutes in the pan.<br></br>
        Store any leftovers in an airtight container in the fridge for up to 4
        days.<br></br>
      </Typography>
    </Card>
  );
}
